import { FC } from 'react';
import { NavLink } from 'react-router-dom';
import { SideNav } from '@servicetitan/anvil2';
import { observer } from 'mobx-react';

import { useDependencies } from '@servicetitan/react-ioc';

import { ManageTenantRoutes } from '../../utils/routes';
import { useManageTenantGeneratePath } from '../../utils/use-manage-tenant-generate-path';
import { ManageTenantStore } from '../../stores/manage-tenant.store';

const sideBarTitles: Record<keyof typeof ManageTenantRoutes, string> = {
    [ManageTenantRoutes.configuration]: 'Configuration',
    [ManageTenantRoutes.partitions]: 'Partitions',
    [ManageTenantRoutes.telecom]: 'Telecom',
};

export const TenantSidebarNav = observer(() => {
    const [{ showTelecom }] = useDependencies(ManageTenantStore);

    return (
        <SideNav>
            <NavItem route={ManageTenantRoutes.configuration} />
            <NavItem route={ManageTenantRoutes.partitions} />
            {showTelecom && <NavItem route={ManageTenantRoutes.telecom} />}
        </SideNav>
    );
});

interface NavItemProps {
    route: keyof typeof ManageTenantRoutes;
}

const NavItem: FC<NavItemProps> = ({ route }) => {
    const { generateManageTenantPath } = useManageTenantGeneratePath();
    const routeValue = ManageTenantRoutes[route];
    const title = sideBarTitles[route];

    return (
        <NavLink to={generateManageTenantPath(routeValue)}>
            {({ isActive }) => (
                <SideNav.Link id={routeValue} active={isActive}>
                    {title}
                </SideNav.Link>
            )}
        </NavLink>
    );
};
